exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".link {\n  color: #f3971f;\n  font-size: 1.4rem;\n  font-weight: bold;\n}\n.link:hover {\n  text-decoration: none;\n}\n", ""]);
